import { numberFormat } from 'lib/utils';
import React, { KeyboardEvent, FocusEvent, useState, useEffect } from 'react';
import EditIcon from './edit.svg';
import styles from './styles.scss';

interface Props {
  placeholder: string;
  value: string;
  prefix: string;
  type: string;
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
}

const EditableInput = ({ placeholder, value, type, prefix, onBlur }: Props): JSX.Element => {
  const [editMode, setEditMode] = useState(false);

  const onSave = (e): void => {
    setEditMode(e.target.value.length === 0);
    onBlur(e);
  };

  useEffect(() => {
    if (value && value.length > 0) {
      setEditMode(false);
    } else {
      setEditMode(true);
    }
  }, []);

  return (
    <>
      {editMode ? (
        <input
          autoFocus
          type={type}
          placeholder={placeholder}
          defaultValue={value || ''}
          onBlur={(e: FocusEvent<HTMLInputElement>): void => onSave(e)}
          onKeyDown={(e: KeyboardEvent<HTMLInputElement>): void => {
            if (e.key === 'Enter') onSave(e);
          }}
          className={styles.input}
        />
      ) : (
        <div
          className={styles.preview}
          onClick={(): void => {
            setEditMode(true);
          }}
        >
          <span className={styles.previewText}>
            {numberFormat.format(parseFloat(value))}
            {prefix}
          </span>
          <EditIcon className={styles.editIcon} />
        </div>
      )}
    </>
  );
};

export default EditableInput;
